import { render, staticRenderFns } from "./BookingNotification.vue?vue&type=template&id=7a08a89e"
import script from "./BookingNotification.vue?vue&type=script&lang=js"
export * from "./BookingNotification.vue?vue&type=script&lang=js"
import style0 from "./BookingNotification.vue?vue&type=style&index=0&id=7a08a89e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports